<template>
  <div class="lg:px-20 md:px-10 sm:px-0">
    <slot />
  </div>
</template>
